module.exports = __webpack_public_path__ + "static/img/build3.06681a31.png";